export enum TimeUnit {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}
export interface Duration {
  unit: TimeUnit
  amount: number
}
